/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import MovieList from "../movieList/movieList";
import { connect } from "react-redux";
import LoadingIndicator from "../loadingIndicator/loadingIndicator";
import ErrorBoundry from "../errorBoundry/errorBoundry";
import { fetchUpcomingMovies } from "../../store/upcoming/actions";
import { getUpcoming } from "../../store/upcoming/selector";
import { loadMore } from "../../store/upcoming/actions";

const Upcoming = ({
  fetchUpcoming,
  loading,
  error,
  moviesUpcoming,
  page,
  loadMoreReq,
  slice
}) => {
  useEffect(() => {
    fetchUpcoming(page);
  }, []);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorBoundry />;
  }

  if (slice) {
    return <MovieList movies={moviesUpcoming.slice(0, 5)} />;
  }

  const getMore = () => loadMoreReq(page + 1);

  return (
    <>
      <MovieList movies={moviesUpcoming} />
      <div className="load-more-wrap">
        <button className="load-more" type="button" onClick={getMore}>
          Load More
        </button>
      </div>
    </>
  );
};

const mapState = state => {
  return {
    moviesUpcoming: getUpcoming(state),
    loading: state.upcoming.loading,
    error: state.upcoming.loading,
    page: state.upcoming.page
  };
};

const mapDispatch = {
  fetchUpcoming: fetchUpcomingMovies,
  loadMoreReq: loadMore
};

export default connect(mapState, mapDispatch)(Upcoming);
